export const FETCH_SINGLE_PODCAST_START = "FETCH_SINGLE_PODCAST_START";
export const FETCH_SINGLE_PODCAST_SUCCESS = "FETCH_SINGLE_PODCAST_SUCCESS";
export const FETCH_SINGLE_PODCAST_FAILED = "FETCH_SINGLE_PODCAST_FAILED";

export const FETCH_ALL_PODCAST_START = "FETCH_ALL_PODCAST_START";
export const FETCH_ALL_PODCAST_SUCCESS = "FETCH_ALL_PODCAST_SUCCESS";
export const FETCH_ALL_PODCAST_FAILED = "FETCH_ALL_PODCAST_FAILED";

